import { Injectable } from '@angular/core';
import {DaoGeneric} from "@Services/base/daoService";
import {Dashboard, DashboardML, DashboardMLDetail} from "app/archivage/common/services/dashboard/dashboard.model";
import {environment} from "@Env/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends DaoGeneric<Dashboard>{
  private url = `${environment.baseUrl}/api_archive/dashboard/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  metrageLibre(mag: DashboardMLDetail) {
    return mag.location__magasin__metrage - mag.ml_theorical_used + mag.ml_destroyed_box;
  }
  metrageLibreAll(ml: DashboardML) {
    return ml.ml_total - ml.ml_theorical_used + ml.ml_destroyed_box;
  }

  metrageOccupe(mag: DashboardMLDetail) {
    return mag.ml_theorical_used - mag.ml_destroyed_box;
  }
  metrageOccupeAll(ml: DashboardML) {
    return ml.ml_theorical_used - ml.ml_destroyed_box;
  }

  orderByFreeSpace(mags: DashboardMLDetail[]) {
    // tri par ml libre decroissant
    return mags.sort(
      (lhd, rhd) => this.metrageLibre(rhd) - this.metrageLibre(lhd)
    );

  }
}
